'use client';
import { getShortcutModifier, isMac } from '@/shared/utils/window';
import classNames from 'classnames';
import { Fragment, ReactNode, useState } from 'react';
import KeyboardShortcutText from './KeyboardShortcutText';

interface SimpleButtonProps {
  className?: string;
  btnClassName?: string;
  dropdownClassName?: string;
  onClick?: () => void;
  isEnabled?: boolean;
  isActive?: boolean;
  disabledMessage?: string;
  tooltipTitle?: string;
  shortcutKey: string;
  shortcutIncludesShift?: boolean;
  icon: ReactNode;
  buttonId: string;
}

const SimpleButton = ({
  className,
  btnClassName,
  dropdownClassName,
  onClick,
  isEnabled,
  disabledMessage,
  isActive,
  icon,
  tooltipTitle,
  shortcutIncludesShift,
  shortcutKey,
  buttonId,
}: SimpleButtonProps) => {
  const [isHoverOpen, setIsHoverOpen] = useState(false);

  const handleHoverEnter = () => {
    setIsHoverOpen(true);
  };

  const handleHoverLeave = () => {
    setIsHoverOpen(false);
  };

  return (
    <div
      className={classNames(
        'dropdown',
        {
          'dropdown-top dropdown-hover': isHoverOpen,
        },
        className
      )}
      data-dropdown-dismiss="true">
      <div
        tabIndex={0}
        role="button"
        data-button-id={buttonId}
        onMouseDown={(e) => {
          e.preventDefault(); // Prevent button from stealing focus from editor
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isEnabled !== false) {
            onClick?.();
          }
        }}
        onMouseEnter={handleHoverEnter}
        onMouseLeave={handleHoverLeave}
        className={classNames(
          'btn btn-square btn-sm',
          {
            'btn-ghost': !isActive,
            'cursor-default !bg-transparent opacity-50': !isEnabled,
          },
          btnClassName
        )}>
        {/* <span className={classNames({ tooltip: !isEnabled })} data-tip={disabledMessage}>
          {icon}
        </span> */}
        {icon}
      </div>

      {isHoverOpen && (
        <div
          tabIndex={0}
          className={classNames(
            'dropdown-content bg-black-default/80 z-[1] mb-0.5 !flex h-[26px] items-center justify-center gap-1.5 rounded-md px-[8px] text-white',
            {
              'min-w-[98px]': isEnabled !== false,
              'min-h-[50px] min-w-[200px]': isEnabled === false,
            },
            dropdownClassName
          )}>
          {isEnabled !== false ? (
            <Fragment>
              <div className="text-[12px]">{tooltipTitle}</div>
              <div className="shortcuts flex gap-1">
                <KeyboardShortcutText
                  shortcut={getShortcutModifier()}
                  className="text-[16px]"
                />
                {shortcutIncludesShift && (
                  <KeyboardShortcutText
                    shortcut="⇧"
                    className={isMac() ? 'pb-0.5 text-[16px]' : 'text-[12px]'}
                  />
                )}

                <KeyboardShortcutText shortcut={shortcutKey} className="text-[12px]" />
              </div>
            </Fragment>
          ) : (
            <div>{disabledMessage}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SimpleButton;
